import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxCurrencyModule } from "ngx-currency";
import { AppRoutingModule } from './app-routing.module';
import { TextMaskModule } from 'angular2-text-mask';
import { AppComponent } from './app.component';
import { PsGuideModule, PsModalModule, PsCalendarModule } from 'porto-seguro-guide';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AcordoComponent } from './acordo/acordo.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ConsultarPropostaComponent } from './consultar-proposta/consultar-proposta.component';
import { DetalhePropostaComponent } from './consultar-proposta/detalhe-proposta/detalhe-proposta.component';
import { PortalModule } from '@angular/cdk/portal';
import { WindowComponent } from './window/window.component';
import { ErrorHandlerService } from './core/error-handler/error-handler.service';
import { ModalService } from './core/modal/modal.service';
import { HTTPStatus, httpApiInterceptorProviders } from './core/interceptor/api-interceptor';
import { ReceberHonorarioComponent } from './receber-honorario/receber-honorario.component';
import { PagamentoHonorarioComponent } from './pagamento-honorario/pagamento-honorario.component';
import { DetalheHonorarioComponent } from './pagamento-honorario/detalhe-honorario/detalhe-honorario.component';
import { RepassarValoresAcordoComponent } from './repassar-valores-acordo/repassar-valores-acordo.component';
import { ConsultarLoteFaturaComponent } from './consultar-lote-fatura/consultar-lote-fatura.component';
import { DetalheLoteFaturaComponent } from './consultar-lote-fatura/detalhe-lote-fatura/detalhe-lote-fatura.component';
import { PagadorLoteFaturaComponent } from './pagador-lote-fatura/pagador-lote-fatura.component';
import { ConciliacaoImportarExtratoComponent } from './conciliacao-importar-extrato/conciliacao-importar-extrato.component';
import { ConciliacaoExtratoComponent } from './conciliacao-extrato/conciliacao-extrato.component';
import { ConciliacaoComponent } from './conciliacao/conciliacao.component';
import { ConciliacaoValidacaoComponent } from './conciliacao-validacao/conciliacao-validacao.component';
import { DetalheValidacaoComponent } from './conciliacao-validacao/detalhe-validacao/detalhe-validacao.component';
import { AuthGuard } from './app-authorization';
import { ApiConfiguration } from './shared/services/acordo-ressarcimento/api/api-configuration';
import { RelatorioAcordoComponent } from './relatorio-acordo/relatorio-acordo.component';
import { RelatorioParcelaComponent } from './relatorio-parcela/relatorio-parcela.component';
import { RelatorioConciliacaoComponent } from './relatorio-conciliacao/relatorio-conciliacao.component';
import { DominioCategoriaDevedorComponent } from './dominio-categoria-devedor/dominio-categoria-devedor.component';
import { DominioContaBancariaComponent } from './dominio-conta-bancaria/dominio-conta-bancaria.component';

@NgModule({
  declarations: [
    AppComponent,
    AcordoComponent,
    NotFoundComponent,
    ConsultarPropostaComponent,
    DetalhePropostaComponent,
    WindowComponent,
    ReceberHonorarioComponent,
    PagamentoHonorarioComponent,
    DetalheHonorarioComponent,
    RepassarValoresAcordoComponent,
    ConsultarLoteFaturaComponent,
    DetalheLoteFaturaComponent,
    PagadorLoteFaturaComponent,
    ConciliacaoImportarExtratoComponent,
    ConciliacaoExtratoComponent,
    ConciliacaoComponent,
    ConciliacaoValidacaoComponent,
    DetalheValidacaoComponent,
    RelatorioAcordoComponent,
    RelatorioParcelaComponent,
    RelatorioConciliacaoComponent,
    DominioCategoriaDevedorComponent,
    DominioContaBancariaComponent,

  ],
  imports: [
    BrowserModule,
    NgxCurrencyModule,
    PortalModule,
    FormsModule,
    TextMaskModule,
    ReactiveFormsModule,
    AppRoutingModule,
    PsModalModule,
    PsCalendarModule,
    PsGuideModule.forRoot()
  ],
  providers: [
    AuthGuard,
    ErrorHandlerService,
    ModalService,
    HTTPStatus,
    httpApiInterceptorProviders,
    ApiConfiguration,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
